export default __webpack_public_path__ + "static/media/mortarboard.6c089df3.png";